import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { UserGuideGroup } from '../types';

export default function GuideBlock({
  guide,
  showGuide,
}: {
  guide: UserGuideGroup;
  showGuide: (slug: string) => void;
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="bg-white shadow overflow-hidden rounded mb-2">
      <div
        className="p-3 flex font-medium justify-between items-center cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <h5>{guide.name}</h5>
        {!expanded ? <FiChevronDown /> : <FiChevronUp />}
      </div>
      {expanded &&
        guide.user_guides.map((userGuide) => (
          <div
            role="button"
            tabIndex={0}
            key={userGuide.id}
            className="block cursor-pointer text-green-600 hover:text-green-700 p-3 border-t border-gray-300 text-sm font-medium"
            onClick={(e) => {
              e.preventDefault();
              showGuide(userGuide.slug);
            }}
          >
            {userGuide.title}
          </div>
        ))}
    </div>
  );
}
